import * as bootstrap from "bootstrap";

// Expose Bootstrap globally
window.bootstrap = bootstrap;
